import AttachFileIcon from "@mui/icons-material/AttachFile";
import { Typography } from "@mui/material";
import { isImage, type FileObject } from "mui-file-dropzone";
import bytesToSize from "../../utils/bytesToSize";

const fileIconSx = {
  height: 100,
  width: "initial",
  maxWidth: "100%",
  color: "text.primary",
  borderRadius: 1,
  zIndex: 5,
};

const labelSx = {
  maxWidth: "100%",
  overflowWrap: "anywhere",
  mt: 0.5,
};

export function attachmentPreviewIcon(
  fileObject: FileObject,
  classes?: { image?: string },
) {
  const { data, file } = fileObject;
  const src = typeof data === "string" ? data : undefined;

  return (
    <>
      {isImage(file) ? (
        <img className={classes?.image} role="presentation" src={src} alt="" />
      ) : (
        <AttachFileIcon sx={fileIconSx} className={classes?.image} />
      )}
      <Typography component="p" variant="body2" sx={labelSx}>
        {file.name}
      </Typography>
      <Typography
        component="p"
        variant="caption"
        color="text.secondary"
        sx={labelSx}
      >
        {bytesToSize(file.size || 0, 1)}
      </Typography>
    </>
  );
}
